<template>
  <div style="min-height: calc(100vh - 70px);display: flex; flex-direction: column">
    <div class="m-subheader position-absolute">
      <div class="d-flex align-items-center">
        <div class="mr-auto">
          <a class="go-back-link" href="#" @click.prevent="$router.go(-1)">
            <i class="la la-arrow-left fa-2x m--padding-15"></i>
          </a>
        </div>
      </div>
    </div>
    <section class="m-content m-content-full align-items-center transaction-detail">
      <div class="gate_center col">
        <div class="row justify-content-center">
          <div class="col-xl-5 col-lg-6 col-md-7 col-xs-9 col-sm-12" v-if="payment">
            <h4 class="text-center">{{payment.title}}</h4>
            <div class="widget">
              <div class="detail-body">
                <div class="detail-image">
                  <img
                    v-if="payment.image"
                    class="my-payment-abc d-flex align-items-center justify-content-center"
                    :src="payment.image"
                  />
                  <div
                    v-else
                    class="text-center my-payment-abc d-flex align-items-center justify-content-center"
                  >{{payment.imageName}}</div>
                </div>
                <div
                  v-for="(paymentItem,index) in payment.items"
                  v-bind:key="`payment-items-${index}`"
                  class="material--input--group m--margin-top-30"
                >
                  <input :title="paymentItem.key" :value="paymentItem.value" type="text" readonly />
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label>{{paymentItem.key}}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="clear"></div>
          <!-- <div
            v-if="payment && payment.tryAgain === true && payment.recurring === false"
            class="col-12 text-center m--margin-top-30"
          >
            <button
              @click="tryAgain(payment.tryAgainPath, item)"
              class="btn btn-primary m-btn--wide"
            >Pay again</button>
          </div>
          <div
            v-if="payment && payment.recurring === true"
            class="col-12 text-center m--margin-top-30"
          >
            <button
              @click="payment.stopFunction"
              class="btn btn-danger m-btn--wide"
            >Stop this payment</button>
          </div> -->
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import vue from "vue";
import { deleteRecurringAirtime } from "./../../../api/airtime/airtimeService";
import { deleteRecurringSendMoney } from "./../../../api/sendMoney/sendMoneyService";
export default {
  props: {
    item: {
      default: null
    }
  },
  data: () => ({
    payment: null
  }),
  components: {},
  mounted() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    if (this.item === null) {
      this.$router.push({ name: "wallet" });
    } else {
      this.payment = this.mapToPayment(this.item);
    }
  },
  methods: {
    stopFunctionAirtime() {
      this.$swal({
        type: "warning",
        title: "Confirm",
        allowEscapeKey: true,
        showConfirmButton: true,
        confirmButtonText: "Yes",
        confirmButtonColor: "#4301C2",
        allowOutsideClick: true,
        showCancelButton: true,
        cancelButtonClass: "btn-primary",
        cancelButtonText: "No",
        html: `Do you want to stop this recurring payment to ${this.item.airtimeTopup.phoneNumber} ?`
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("loader", true);
          deleteRecurringAirtime(this.item.id)
            .then(response => {
              this.$swal({
                type: "success",
                title: response.response.message,
                showConfirmButton: true,
                confirmButtonText: "GO BACK HOME",
                allowEscapeKey: false,
                allowOutsideClick: false,
                showCancelButton: false,
                confirmButtonColor: "#4301C2"
              }).then(result => {
                this.$store.dispatch("redirect", "wallet");
              });
            })
            .catch(error => {
              console.log(error);
              this.$store.dispatch("handleError", {
                response: error,
                can_cancel: true
              });
            })
            .finally(() => {
              this.$store.dispatch("loader", false);
            });
        }
      });
    },
    stopFunctionTransfer() {
      this.$swal({
        type: "warning",
        title: "Confirm",
        allowEscapeKey: true,
        showConfirmButton: true,
        confirmButtonText: "Yes",
        confirmButtonColor: "#4301C2",
        allowOutsideClick: true,
        showCancelButton: true,
        cancelButtonClass: "btn-primary",
        cancelButtonText: "No",
        html: `Do you want to stop this recurring payment to ${this.item.transferRecipient.accountName} ?`
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("loader", true);
          deleteRecurringSendMoney(this.item.id)
            .then(response => {
              this.$swal({
                type: "success",
                title: response.response.message,
                showConfirmButton: true,
                confirmButtonText: "GO BACK HOME",
                allowEscapeKey: false,
                allowOutsideClick: false,
                showCancelButton: false,
                confirmButtonColor: "#4301C2"
              }).then(result => {
                this.$store.dispatch("redirect", "wallet");
              });
            })
            .catch(error => {
              console.log(error);
              this.$store.dispatch("handleError", {
                response: error,
                can_cancel: true
              });
            })
            .finally(() => {
              this.$store.dispatch("loader", false);
            });
        }
      });
    },
    mapToPayment(item) {
      let res = null;
      if (item.payableType === "wallet_topup") {
        res = {
          title: "Fund wallet details",
          image: null,
          imageName: item.walletTopup.accountName.substring(0, 1).toUpperCase(),
          tryAgain: true,
          tryAgainPath: "fund-wallet",
          recurring: false,
          items: [
            { key: "Wallet account number", value: item.walletTopup.walletId },
            { key: "Account name", value: item.walletTopup.accountName },
            { key: "Amount", value: this.toMoney(item.amount) },
            { key: "Date", value: this.toDate(item.entryDate) }
          ]
        };
      } else if (item.payableType === "transfer") {
        res = {
          title: "Transfer details",
          image: null,
          imageName: item.transferRecipient.accountName
            .substring(0, 1)
            .toUpperCase(),
          tryAgain: true,
          tryAgainPath: "send-money-to-bank",
          recurring: false,
          items: [
            { key: "Saved name", value: item.displayName },
            {
              key: "Recipient's name",
              value: item.transferRecipient.accountName
            },
            {
              key: "Recipient's account number",
              value: item.transferRecipient.accountNumber
            },
            { key: "Recipient's bank", value: item.transferRecipient.bankName },
            { key: "Amount", value: this.toMoney(item.amount) }
          ]
        };
        if (item.recurring === true) {
          res.items = [
            ...res.items,
            {
              key: "Next repayment date",
              value: this.toDate(item.repeatSetting.nextDate)
            },
            {
              key: "frequency",
              value: item.repeatSetting.frequency.toLowerCase()
            }
          ];
          res.recurring = true;
          res.stopFunction = this.stopFunctionTransfer;
        } else {
          res.items = [
            ...res.items,
            { key: "Date", value: this.toDate(item.createdAt) }
          ];
        }
      } else if (item.payableType === "airtime_topup") {
        res = {
          title: "Recharge details",
          image: item.airtimeTopup.mobileNetworkOperator.logoUrl,
          imageName: null,
          tryAgain: true,
          tryAgainPath: "buy-airtime",
          recurring: false,
          items: [
            { key: "Saved name", value: item.displayName },
            { key: "Phone number", value: item.airtimeTopup.phoneNumber },
            { key: "Amount", value: this.toMoney(item.amount) },
            {
              key: "Service Charge",
              value:
                item.airtimeTopup.mobileNetworkOperator.serviceCharge === 0
                  ? "Free"
                  : this.toMoney(
                      item.airtimeTopup.mobileNetworkOperator.serviceCharge
                    )
            }
          ]
        };
        if (item.recurring === true) {
          res.items = [
            ...res.items,
            {
              key: "Next repayment date",
              value: this.toDate(item.repeatSetting.nextDate)
            },
            {
              key: "frequency",
              value: item.repeatSetting.frequency.toLowerCase()
            }
          ];
          res.recurring = true;
          res.stopFunction = this.stopFunctionAirtime;
        } else {
          res.items = [
            ...res.items,
            { key: "Date", value: this.toDate(item.createdAt) }
          ];
        }
      } else if (item.payableType === "bill") {
        res = {
          title: "Bill details",
          image: item.bill.biller.meta.logoUrl,
          imageName: null,
          tryAgain: true,
          tryAgainPath: "under-construction",
          recurring: false,
          items: [
            { key: "Saved name", value: item.displayName },
            { key: "Product", value: item.bill.biller.meta.qtCategory },
            { key: "prepaid", value: "" },
            {
              key: "Meter Number",
              value: item.bill.fieldValues
                ? item.bill.fieldValues.customerfield1
                : ""
            },
            { key: "Amount", value: this.toMoney(item.amount) },
            {
              key: "Service Charge",
              value:
                item.bill.biller === 0
                  ? "Free"
                  : this.toMoney(item.bill.biller.serviceCharge)
            },
            { key: "Date", value: this.toDate(item.createdAt) }
          ]
        };
      } else if (item.payableType === "investment_deposit") {
        res = {
          title: "Investment deposit",
          image: null,
          imageName: item.displayName.substring(0, 1).toUpperCase(),
          tryAgain: true,
          tryAgainPath: "under-construction",
          recurring: false,
          items: [
            { key: "Saved name", value: item.displayName },
            { key: "Account name", value: item.investmentDeposit.displayName },
            { key: "Account number", value: item.investmentDeposit.accountId },
            { key: "product", value: item.investmentDeposit.productId },
            { key: "Amount", value: this.toMoney(item.amount) },
            { key: "Date", value: this.toDate(item.createdAt) }
          ]
        };
      } else {
        res = {
          title: "Payment details",
          image: null,
          imageName: item.displayName.substring(0, 1).toUpperCase(),
          tryAgain: true,
          tryAgainPath: "under-construction",
          recurring: false,
          items: [
            { key: "Saved name", value: item.displayName },
            { key: "Amount", value: this.toMoney(item.amount) },
            { key: "Date", value: this.toDate(item.createdAt) }
          ]
        };
      }
      return res;
    },
    toMoney(amount) {
      return (parseFloat(amount) / 100).toLocaleString("en", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    toDate(date) {
      return moment(date).format("MM/DD/YYYY, LT");
    },
    tryAgain(tryAgainPath, item) {
      this.$router.push({
        name: tryAgainPath,
        params: { initalTransaction: item }
      });
    }
  }
};
</script>
